import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  if (!(await isPushSupported())) return "unsupported";
  const perm = Notification.permission;
  if (perm === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub ? "subscribed" : perm === "granted" ? "granted" : "prompt";
}

export async function enablePush() {
  if (!(await isPushSupported())) throw new Error("Push not supported");
  const { data: v } = await api.get("/push/vapid");
  if (!v.enabled || !v.public_key) throw new Error("Push disabled on server");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission not granted");
  let reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(v.public_key),
  });
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    user_agent: navigator.userAgent,
  });
  return true;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe();
  }
}
